import Token from '@/di/di.token'

import useDi from '../useDi'

export default function usePlantService() {
  const { container } = useDi()
  const service = container.get(Token.PLANT_SERVICE)
  return { service }
}
